import './app.scss';
import React, {Component} from 'react'
import { Switch, Route, Redirect } from 'react-router';
import PrivateRoute from './private-route';
import { BrowserRouter } from 'react-router-dom';
import LoginPage from './pages/login';
import Header from './components/header';
import Footer from './components/footer';
import Messages from './pages/messages';
import Invitations from './pages/invitations';
import Settings from './pages/settings';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="app-wrapper">
          <Header />
          <main className="app">
            <div className="container">
              <Switch>
                <Route path="/login" component={LoginPage} />
                <PrivateRoute path="/feedback" component={Messages} />
                <PrivateRoute path="/invitations" component={Invitations} />
                <PrivateRoute path="/settings" component={Settings} />
                <PrivateRoute path="/settings/:portal" component={Settings} />
                <Redirect to="/feedback" />
              </Switch>
            </div>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app.js